/* VELARA — product page: gallery + variant selection + quantity. */
(function () {
  'use strict';
  var T = window.VELARA_I18N || {};
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ---- gallery ---- */
  var main = $('[data-gal-main]');
  if (main) {
    $$('[data-gal-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full;
        main.alt = t.dataset.alt || '';
        $$('[data-gal-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---- quantity stepper ---- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, b.dataset.qty === 'up' ? v + 1 : v - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- variants ---- */
  var root = $('[data-product]');
  if (!root) return;
  var dataEl = $('[data-variants]');
  if (!dataEl) return;
  var variants;
  try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

  var selects = $$('[data-option]');
  var idInput = $('[data-variant-id]');
  var priceNow = $('[data-price-now]');
  var priceWas = $('[data-price-was]');
  var atc = $('[data-atc]');

  function chosen() { return selects.map(function (s) { return s.value; }); }

  function match() {
    var picked = chosen();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < picked.length; j++) { if (v.options[j] !== picked[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(d.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  function update() {
    var v = match();
    if (!v) {
      if (atc) { atc.disabled = true; atc.textContent = T.unavailable || 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = v.id;
    if (priceNow) priceNow.textContent = fmt(v.price);
    if (priceWas) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceWas.textContent = fmt(v.compare_at_price); priceWas.hidden = false;
      } else { priceWas.hidden = true; }
    }
    if (atc) {
      atc.disabled = !v.available;
      atc.textContent = v.available
        ? (atc.dataset.label || T.addToCart || 'Add to bag')
        : (T.soldOut || 'Sold out');
    }
    if (v.featured_image && main) {
      main.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
    }
    if (history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
})();
